<template>
  <el-row class="search-row">
    <el-row class="search-bar" style="background-color: #f5f5f5;border-top:solid 1px #e6e6e6;border-left:solid 1px #e6e6e6;border-right:solid 1px #e6e6e6">
      <el-col :span="2" style="text-align: center"><span class="search-key">{{title}}</span></el-col>
      <el-col :span="22" style="background-color: #fff">
        <el-row>
          <el-col :span="22">
            <el-menu :default-active="activedMenu" mode="horizontal" @select="handleSelect" text-color="#4c4c4c">
                <el-col :span="2">
                <el-menu-item index="" >全部</el-menu-item>
                </el-col>
                <el-col :span="3" v-for="(item, key) in list" :key="key" v-show="key < num">
                  <el-menu-item v-if="getByteLen(item.value) <= 15" :index="item.key" >{{item.value}}</el-menu-item>

                  <el-tooltip v-else effect="light" :content="item.value" placement="bottom">
                    <el-menu-item :index="item.key" >{{item.value | cutStr(12)}}</el-menu-item>
                  </el-tooltip>
                </el-col>
            </el-menu>
          </el-col>
          <el-col :span="1" style="background-color: #FFFFFF;text-align: center;line-height: 60px;">
            <div v-if="data.length > 14">
              <el-button size="mini" @click="showMore">{{isShow ? '展开' : '收起'}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></el-button>
            </div>
            <div v-else>&nbsp;</div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
  import StrKit from '@/utils/str-kit'
  import Constants from '@/constants/constants'
  import {isNullOrUndefined} from "@/utils";
  import {deepCopy} from '../utils'
  export default {
    name: 'SearchBar',
    props: {
      title: {
        type: String,
        default: ''
      },
      data: {
        type: Array,
        default () {
          return [{key: '', value: '全部'}]
        }
      },
      procurementType: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        isShow: true,
        num: 14,
        procurementTypeList: [],
        activedMenu:'',
        list:[],
        isFirst:0
      }
    },
    created () {
      Constants.procurementTypeList2.forEach((value, index) => {
        this.procurementTypeList.push(value)
      })
      this.init()
    },
    watch:{
      data(){
        this.init()
      },
      procurementType() {
        this.activedMenu = this.procurementType
      }
    },
    methods: {
      init(){
        this.list = deepCopy(this.data)
        if (this.$route.query.procurementType && this.title === '采购类型' && this.procurementTypeList.filter(item => item.value === this.$route.query.procurementType).length !== 0) {
          // this.activedMenu =  this.procurementTypeList.filter(item => item.value === this.$route.query.procurementType)[0].key
          this.handleSelect( this.procurementTypeList.filter(item => item.value === this.$route.query.procurementType)[0].key)
          return
        }
        if(!isNullOrUndefined(this.$route.query.collegeName)&&this.data.length >0 &&this.title =='采购单位'){
          let index = this.data.findIndex((item) => item.value === this.$route.query.collegeName)
          if(index != -1&&this.isFirst == 0){
            let obj = this.data.filter((item) => item.value === this.$route.query.collegeName)[0]
            this.list.splice(this.data.findIndex((item) => item.value === this.$route.query.collegeName),1)
            this.list.unshift(obj)
            this.handleSelect(obj.key)
            this.isFirst ++
          }else{
            this.handleSelect('')
          }

          return
        }
        return this.activedMenu =''
      },
      handleSelect (index, indexPath) {
        console.log('index',index)
        this.activedMenu =index
        this.value = index
        this.$emit('select', index)
      },
      getByteLen (value) {
        return StrKit.getByteLen(value)
      },
      // 查看更多
      showMore () {
        this.isShow = !this.isShow
        this.num = this.isShow ? 14 : this.data.length
      },
      /* 根据路由决定菜单高亮 */
      // activedMenu (val) {
      //
      // }
    }
  }
</script>

<style>
  .search-row .el-menu.el-menu--horizontal {
    border-bottom: solid 0px #e6e6e6!important;
  }

  .search-bar .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none;
    color: #1467b3;
  }

  .search-bar .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,.search-bar .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    color: #1467b3;
  }

  .search-bar .el-menu-item {
    font-size: 12px;
  }

  .search-bar .el-menu-item.is-active {
    color: #1467b3;
  }

  .search-bar .el-menu-item:focus, .search-bar .el-menu-item:hover {
    background: none!important;
    color: #1467b3!important;
  }

</style>
<style scoped>
  .search-key {
    color: #1467b3;
    line-height: 60px;
    font-size: 12px;
  }
  .Amenu{
    display: inline-block;
    color: blue;
    text-decoration:underline;
  }
  .Amenu:hover{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/search-bar.vue